// Figma横スクロールバー: トラック全幅 #DADADA / つまみ 50×2px #666
// data-thumb-width でつまみ幅上書き（総合TOP PICK UP は 100）
const DEFAULT_THUMB_W = 50;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const getMaxScroll = (scrollEl) => Math.max(0, scrollEl.scrollWidth - scrollEl.clientWidth);

const setScrollLeft = (scrollEl, left) => {
    scrollEl.scrollLeft = clamp(left, 0, getMaxScroll(scrollEl));
};

const syncThumb = (scrollEl, thumbEl, trackEl, thumbW) => {
    const maxScroll = getMaxScroll(scrollEl);
    if (maxScroll <= 0) {
        trackEl.hidden = true;
        thumbEl.style.transform = 'translateX(0)';
        return;
    }
    trackEl.hidden = false;
    const trackTravel = Math.max(0, trackEl.clientWidth - thumbW);
    const ratio = scrollEl.scrollLeft / maxScroll;
    thumbEl.style.transform = `translateX(${trackTravel * ratio}px)`;
};

const bindWheelScroll = (scrollEl, update) => {
    scrollEl.addEventListener('wheel', (event) => {
        const maxScroll = getMaxScroll(scrollEl);
        if (maxScroll <= 0) return;

        const delta = Math.abs(event.deltaX) >= Math.abs(event.deltaY)
            ? event.deltaX
            : event.deltaY;
        if (delta === 0) return;

        const current = scrollEl.scrollLeft;
        const next = clamp(current + delta, 0, maxScroll);
        if (next === current) return;

        event.preventDefault();
        scrollEl.scrollLeft = next;
        update();
    }, { passive: false });
};

const bindDragScroll = (scrollEl, trackEl, thumbEl, thumbW, update) => {
    let pointerId = null;
    let grabOffset = thumbW / 2;

    const scrollByClientX = (clientX) => {
        const maxScroll = getMaxScroll(scrollEl);
        const trackTravel = Math.max(0, trackEl.clientWidth - thumbW);
        if (maxScroll <= 0 || trackTravel <= 0) return;

        const trackRect = trackEl.getBoundingClientRect();
        const thumbLeft = clamp(clientX - trackRect.left - grabOffset, 0, trackTravel);
        setScrollLeft(scrollEl, (thumbLeft / trackTravel) * maxScroll);
        update();
    };

    trackEl.addEventListener('pointerdown', (event) => {
        if (getMaxScroll(scrollEl) <= 0) return;

        pointerId = event.pointerId;
        const thumbRect = thumbEl.getBoundingClientRect();
        grabOffset = event.target === thumbEl
            ? clamp(event.clientX - thumbRect.left, 0, thumbW)
            : thumbW / 2;

        event.preventDefault();
        trackEl.setPointerCapture?.(pointerId);
        scrollByClientX(event.clientX);
    });

    trackEl.addEventListener('pointermove', (event) => {
        if (pointerId !== event.pointerId) return;
        event.preventDefault();
        scrollByClientX(event.clientX);
    });

    const endDrag = (event) => {
        if (pointerId !== event.pointerId) return;
        trackEl.releasePointerCapture?.(pointerId);
        pointerId = null;
    };

    trackEl.addEventListener('pointerup', endDrag);
    trackEl.addEventListener('pointercancel', endDrag);
};

const bind = (root) => {
    const scrollEl = root.querySelector('[data-h-scroll]') || root.querySelector('.js-forms-h-scroll');
    const trackEl = root.querySelector('.c-forms-h-scroll-bar');
    const thumbEl = root.querySelector('.js-forms-h-scroll-thumb');
    if (!scrollEl || !trackEl || !thumbEl) return;
    // Ajaxで後から差し込まれたスクロール領域（TOPのおすすめ横スクロール等）にも
    // 張り直せるよう main() は何度でも呼べる。同じ root への二重登録だけ避ける
    if (root.dataset.hScrollBound) return;
    root.dataset.hScrollBound = '1';

    const thumbW = Number(root.dataset.thumbWidth) || DEFAULT_THUMB_W;
    thumbEl.style.width = `${thumbW}px`;

    const update = () => syncThumb(scrollEl, thumbEl, trackEl, thumbW);
    update();
    scrollEl.addEventListener('scroll', update, { passive: true });
    bindWheelScroll(scrollEl, update);
    bindDragScroll(scrollEl, trackEl, thumbEl, thumbW, update);
    window.addEventListener('resize', update);

    if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(update);
        ro.observe(scrollEl);
        if (scrollEl.firstElementChild) ro.observe(scrollEl.firstElementChild);
    }
};

const main = () => {
    document.querySelectorAll('.js-forms-h-scroll-root').forEach(bind);
};

export default main;
